<template>
  <div class="previewClipartsComponent">
      <app-previewclipart v-for="clipart in label.cliparts_blocks" :clipart="clipart" :label="label" ></app-previewclipart>
  </div>
</template>
<script>
    import PreviewClipart from './PreviewClipart';

    export default {
        props : ['label'],
        components : {
            appPreviewclipart : PreviewClipart
        }

    }
</script>
<style>
    .previewClipartsComponent {
        width   : 100%;
        height  : 100%;
         position: absolute;
        top:0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Preview/PreviewCliparts.vue